import styled from "styled-components";

import { COLOR_VALUES } from "shared/config/colors";

export const StyledIcon = styled.svg`
    color: ${(props) => COLOR_VALUES[props.$color] ?? ""};
    display: block;
`;
